var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Body from "syf-component-library/ui/typography/Body";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  padding: 40px;\n"], ["\n  text-align: center;\n  padding: 40px;\n"])));
var TextBlock = styled(Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: ", "px;\n"], ["\n  font-size: ", "px;\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b;
    return size;
});
var Image = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 168px;\n"], ["\n  width: 168px;\n"])));
export var StatusMessage = {
    Container: Container,
    TextBlock: TextBlock,
    Image: Image,
};
var templateObject_1, templateObject_2, templateObject_3;
